<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewOvertime"
            :searchFilters="searchFilters"
            @searchPage="searchOvertimes"
            @resetFilters="resetFilters"
            @removeItem="removeOvertime"
            @removeSelectedItems="removeOvertimes"
            @printList="printovertimeList"
            @printExcel="downloadDeductionsExcel"
            @printCSV="downloadDeductionsCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="overtimeList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveOvertime" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import PrintJS from 'print-js';

export default{
    name: 'Overtime_Policy',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const ledComponentKey = ref(0);
        const idField = 'overtime_policy_id';
        const addButtonLabel = ref('New Overtime');
        const addingRight = ref('Adding Overtime Policies');
        const removingRight = ref('Deleting Overtime Policies');
        const rightsModule = ref('HR');
        const title = ref('Overtime Details');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const overtimeList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('500px');
        const modal_width = ref('40vw');
        const ledgerID = ref('');
        const isEditing = computed(()=> store.state.Overtime.isEditing);
        const selectedOvertime = computed(()=> store.state.Overtime.selectedOvertime);
        const selectedLedger = computed(()=> store.state.Overtime.selectedLedger);
        const ledgerArray = computed(() => store.state.Ledgers.ledgerArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key:"name"},
            {label: "Date", key:"date"},
            {label: "Type", key: "charge_type"},
            {label: "Taxed", key:"taxation_status"},
            {label: "Charge Mode", key:"charge_mode"},
            {label: "Rate", key:"rate"},
            {label: "Hourly Mode", key:"hourly_rate_mode"},
            {label: "Hourly Rate", key:"hourly_rate"},
            {label: "Posting Account", key:"posting_account_name"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Overtime', rightName: 'Editing Overtime Policies'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Overtime', rightName: 'Deleting Overtime Policies'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const name_search = ref('');;
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: name_search, width:56,},
        ]);
        const fetchLedgers = async() =>{
            await store.dispatch('Ledgers/fetchLedgers', {company:companyID.value})
        };
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const handleSelectedLedger = async(option) =>{
            await store.dispatch('Ledgers/handleSelectedLedger', option)
            ledgerID.value = store.state.Ledgers.ledgerID;
        };
        const clearSelectedLedger = async() =>{
            await store.dispatch('Ledgers/updateState', {ledgerID: ''});
            ledgerID.value = store.state.Ledgers.ledgerID;
        }
        const formFields = ref([]);
        const ledgerValue = computed(() => {
           return (selectedOvertime.value && selectedOvertime.value.posting_account && !ledgerID.value) ? selectedOvertime.value.posting_account.ledger_id : ledgerID.value;

        });
        const displayHourlyRate = (value) =>{
            if(value == "Provided"){
                formFields.value[7].hidden = false;
            }else if(value == "Default"){
                formFields.value[7].hidden = true;
            }
        };
        const updateFormFields = () => {
            formFields.value = [
                
                { type: 'text', name: 'name',label: "Name", value: selectedOvertime.value?.name, required: true },
                { type: 'date', name: 'date',label: "Effective Date", value: selectedOvertime.value?.date, required: true },
                { type: 'dropdown', name: 'charge_mode',label: "Charge Mode", value: selectedOvertime.value?.charge_mode || 'Pro-rate', placeholder: "", required: true, options: [{ text: 'Pro-rate', value: 'Pro-rate' }, { text: 'Round-up', value: 'Round-up' }, { text: 'Round-down', value: 'Round-down' }] },
                { type: 'dropdown', name: 'charge_type',label: "Charge Type", value: selectedOvertime.value?.charge_type || 'Rate', placeholder: "", required: true, options: [{ text: 'Fixed Amount', value: 'Fixed Amount' }, { text: 'Rate', value: 'Rate' }] },
                { type: 'number', name: 'rate',label: "Rate/Amount", value: selectedOvertime.value?.rate || 0, required: true },
                { type: 'dropdown', name: 'taxation_status',label: "Taxed", value: selectedOvertime.value?.taxation_status || 'Yes', placeholder: "", required: true, options: [{ text: 'Yes', value: 'Yes' }, { text: 'No', value: 'No' }] },
                { type: 'dropdown', name: 'hourly_rate_mode',label: "Hourly Rate Mode", value: selectedOvertime.value?.hourly_rate_mode || 'Default', placeholder: "", required: true, options: [{ text: 'Default', value: 'Default' }, { text: 'Provided', value: 'Provided' }], method: displayHourlyRate },
                { type: 'number', name: 'hourly_rate',label: "Hourly Rate", value: selectedOvertime.value?.hourly_rate || 0, required: false, hidden: true },      
                {  
                    type:'search-dropdown', label:"Posting Account", value: ledgerValue.value, componentKey: ledComponentKey,
                    selectOptions: ledgerArray, optionSelected: handleSelectedLedger, required: true,
                    searchPlaceholder: 'Select Posting Account...', dropdownWidth: '500px', updateValue: selectedLedger.value,
                    clearSearch: clearSelectedLedger
                },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            ledComponentKey.value += 1;
            ledgerID.value = '';
        }

        watch([selectedOvertime, selectedLedger], () => {
            if (selectedOvertime.value && selectedLedger.value) {
                ledComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createOvertimePolicy = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                date: formFields.value[1].value,
                rate: formFields.value[4].value,
                charge_mode: formFields.value[2].value,
                charge_type: formFields.value[3].value,
                hourly_rate_mode: formFields.value[6].value,
                hourly_rate: formFields.value[7].value || 0,
                taxation_status: formFields.value[5].value || 'Yes',
                posting_account: ledgerID.value,
                posting_account_id: ledgerID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(ledgerValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Overtime/createOvertimePolicy', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Overtime created successfully!');
                        handleReset();
                        ledComponentKey.value += 1;
                    } else {
                        toast.error('An error occurred while creating the Overtime.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Overtime: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchOvertimes();
                }
            }
        }
        const updateOvertimePolicy = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                overtime_policy: selectedOvertime.value.overtime_policy_id,
                name: formFields.value[0].value,
                date: formFields.value[1].value,
                rate: formFields.value[4].value,
                charge_mode: formFields.value[2].value,
                charge_type: formFields.value[3].value,
                hourly_rate_mode: formFields.value[6].value,
                hourly_rate: formFields.value[7].value || 0,
                taxation_status: formFields.value[5].value || 'Yes',
                posting_account: ledgerValue.value,
                posting_account_id: ledgerValue.value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(ledgerValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Overtime/updateOvertimePolicy', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        ledComponentKey.value += 1;
                        toast.success("Overtime updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Overtime.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Overtime: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Overtime/updateState",{selectedOvertime:null})
                    searchOvertimes();
                }             
            }
        }
        const saveOvertime = () =>{
            if(isEditing.value == true){
                updateOvertimePolicy();
            }else{
                createOvertimePolicy();
            }
        }
        const removeOvertime = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    overtime_policy: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Overtime/deleteOvertimePolicy',formData)
                    if(response && response.status == 200){
                        toast.success("Overtime Removed Succesfully");
                        searchOvertimes();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Overtime: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Overtime") 
            }else{
                toast.error("Please Select An Overtime To Remove")
            }
        }
        const removeOvertimes = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    overtime_policy: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Overtime/deleteOvertimePolicy',formData)
                    if(response && response.status == 200){
                        toast.success("Overtime(s) Removed Succesfully");
                        searchOvertimes();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Overtime: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Overtime To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchOvertimes = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/overtime-policies-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                overtimeList.value = response.data.results;
                store.commit('Overtime/LIST_OVERTIMES', overtimeList.value)
                propResults.value = response.data;
                propArrLen.value = overtimeList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchOvertimes(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            name_search.value = "";
            searchOvertimes();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchOvertimes();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchOvertimes();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchOvertimes();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchOvertimes();
            // scrollToTop();
        }
        const addNewOvertime = () =>{
            store.dispatch("Overtime/updateState",{selectedOvertime:null, selectedLedger:null});
            ledComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Overtime/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.33';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const overtimeID = row['overtime_policy_id'];
                let formData = {
                    company: companyID.value,
                    overtime_policy: overtimeID
                }
                await store.dispatch('Overtime/fetchOvertimePolicy',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.33';

            }else if(action == 'delete'){
                const overtimeID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    overtime_policy: overtimeID
                }
                await store.dispatch('Overtime/deleteOvertimePolicy',formData).
                then(()=>{
                    searchOvertimes();
                })
            }else if(action == 'view'){
                
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printovertimeList = () =>{
            showLoader();
            let formData = {
                deduction_name: name_search.value,
                deduction_type: deduction_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 

            axios
            .post("api/v1/export-deductions-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadDeductionsExcel = () =>{
            showLoader();
            let formData = {
                deduction_name: name_search.value,
                deduction_type: deduction_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios.post("api/v1/export-deductions-excel/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Overtimes.xlsx');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadDeductionsCSV = () =>{
            showLoader();
            let formData = {
                deduction_name: name_search.value,
                deduction_type: deduction_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios.post("api/v1/export-deductions-csv/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Deductions.csv');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        onBeforeMount(()=>{
            searchOvertimes();
            fetchLedgers();
        })
        return{
            title, searchOvertimes,resetFilters, addButtonLabel, searchFilters, tableColumns, overtimeList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewOvertime, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveOvertime, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeOvertime, removeOvertimes,addingRight,removingRight,rightsModule,printovertimeList,selectSearchQuantity,selectedValue,
            downloadDeductionsCSV,downloadDeductionsExcel
        }
    }
};
</script>